import { createContext } from 'react';

const CustomizationContext = createContext();
export default CustomizationContext;
